import { STORAGE_KEY_ON_BOARDING_ADD_HIDE } from '../../constants/config';
import { getLocalStorage } from './getLocalStorage';
export var hideOnBoardingAddVisible = function hideOnBoardingAddVisible() {
  var storage = getLocalStorage();
  if (storage) {
    storage.setItem(STORAGE_KEY_ON_BOARDING_ADD_HIDE, '1');
  }
};